/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalali'
import TMS from '../BaseComponent/TMS'
import {MDBContainer, MDBRow, MDBCol} from 'mdbreact'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SinglePicker from '../BaseComponent/singlePicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes'
import AutoComplete from '../BaseComponent/autocomplete'
import USER_MANAGE from '../BaseComponent/USERMANAGE'

class ManagerCreateTask extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: '',
      providers: [],
      providerId: '',
      products: [],
      productId: '',
      activityDate: '',
      sections: [],
      tasks: [],
      timeMinuteMax: '',
      timeMinuteMin: '',
      needProvider: 'notForce',
      needProduct: 'notForce',
      sectionId: '',
      taskType: '',
      department: [],
      departmentId: '',
      editableCount: '',
      defaultCount: '',
      selectedProductFromList: [],
      init: true,
      users: [],
      userId: ''
    }
  }

  changeTaskType(e) {
    let target = e.target
    let value = e.target.value
    let name = e.target.name
    sessionStorage.setItem('taskType', value)
    sessionStorage.setItem('needProduct', target.options[target.selectedIndex].getAttribute('data-needProduct'))
    sessionStorage.setItem('needProvider', target.options[target.selectedIndex].getAttribute('data-needProvider'))
    sessionStorage.setItem('timeMinuteMin', target.options[target.selectedIndex].getAttribute('data-timeMinuteMin'))
    sessionStorage.setItem('timeMinuteMax', target.options[target.selectedIndex].getAttribute('data-timeMinuteMax'))
    sessionStorage.setItem('editableCount', target.options[target.selectedIndex].getAttribute('data-editableCount'))
    sessionStorage.setItem('defaultCount', target.options[target.selectedIndex].getAttribute('data-defaultCount'))

    this.setState({
      [name]: value
    })
    this.setState({
      timeMinuteMin: target.options[target.selectedIndex].getAttribute('data-timeMinuteMin'),
      timeMinuteMax: target.options[target.selectedIndex].getAttribute('data-timeMinuteMax'),
      needProduct: target.options[target.selectedIndex].getAttribute('data-needProduct'),
      needProvider: target.options[target.selectedIndex].getAttribute('data-needProvider'),
      editableCount: target.options[target.selectedIndex].getAttribute('data-editableCount'),
      defaultCount: target.options[target.selectedIndex].getAttribute('data-defaultCount')
    })
  }

  changeSec(e) {
    let value = e.target.value
    let name = e.target.name

    sessionStorage.setItem('sectionId', value)

    this.setState({
      [name]: value
    })
    if (value === '') {
      this.setState({
        tasks: []
      })
    } else {
      this.loadTasks(value)
    }
  }

  getOperators = () => {
    return http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var users = response.data.object
        for (let i = 0; i < users.length; i++) {
          users[i]['value'] = users[i].personId
          users[i]['label'] = users[i].personId + ' - ' + users[i].name
        }
        this.setState({
          users: response.data.object
        })
      }
    })
  }

  getUserValue = (userId) => {
    if (userId === null) {
      this.setState({
        userId: ''
      })
    } else {
      this.setState({
        userId
      })
    }
  }

  componentDidMount() {
    this.getOperators()
    if (sessionStorage.getItem('sectionId')) {
      this.setState({
        sectionId: sessionStorage.getItem('sectionId')
      })

      http
        .get(`${TMS.TMS_MANAGE_BASE_TASK_LIST}?sectionId=${sessionStorage.getItem('sectionId')}`, {})
        .then((response) => {
          if (response.data.error === null) {
            let res = response.data.object
            res.forEach((item) => {
              if (item.needProduct === 1) {
                item.needProduct = 'force'
              } else if (item.needProduct === 0) {
                item.needProduct = 'notForce'
              } else if (item.needProduct === -1) {
                item.needProduct = 'prevent'
              }

              if (item.needProvider === 1) {
                item.needProvider = 'force'
              } else if (item.needProvider === 0) {
                item.needProvider = 'notForce'
              } else if (item.needProvider === -1) {
                item.needProvider = 'prevent'
              }
            })
            this.setState({
              tasks: response.data.object
            })
          } else {
            this.setState({
              tasks: []
            })
          }
        })
    }

    if (sessionStorage.getItem('taskType')) {
      this.setState({
        taskType: sessionStorage.getItem('taskType'),
        needProduct: sessionStorage.getItem('needProduct'),
        needProvider: sessionStorage.getItem('needProvider'),
        timeMinuteMin: sessionStorage.getItem('timeMinuteMin'),
        timeMinuteMax: sessionStorage.getItem('timeMinuteMax'),
        editableCount: sessionStorage.getItem('editableCount'),
        defaultCount: sessionStorage.getItem('defaultCount')
      })
    }

    if (sessionStorage.getItem('providerId')) {
      this.setState(
        {
          providerId: sessionStorage.getItem('providerId'),
          init: false
        },
        () => {
          let providerId = sessionStorage.getItem('providerId')
          http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PRODUCT}?providerId=${providerId}`, {}).then((response) => {
            if (response.data.error === null) {
              var products = response.data.object
              for (let i = 0; i < products.length; i++) {
                products[i]['value'] = products[i].productId
                products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
              }
              this.setState({
                products: response.data.object
              })
            } else {
              this.setState({
                products: []
              })
            }
          })
        }
      )
    } else {
      this.setState({
        init: false
      })
    }

    if (sessionStorage.getItem('departmentId')) {
      this.setState({
        departmentId: sessionStorage.getItem('departmentId')
      })

      http
        .get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?departmentId=${sessionStorage.getItem('departmentId')}`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              sections: response.data.object
            })
          } else {
            this.setState({
              sections: []
            })
          }
        })
    }
    http.get(TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
        if (response.data.object.length === 1) {
          let departmentId = response.data.object[0].id
          this.loadSections(departmentId)
        }
      }
    })
  }

  loadSections = (departmentId) => {
    http.get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?departmentId=${departmentId}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          sections: response.data.object
        })
        if (response.data.object.length === 1) {
          let sectionId = response.data.object[0].id
          this.loadTasks(sectionId)
        }
      } else {
        this.setState({
          sections: []
        })
      }
    })
  }

  loadTasks = (sectionId) => {
    http.get(`${TMS.TMS_MANAGE_BASE_TASK_LIST}?sectionId=${sectionId}`, {}).then((response) => {
      if (response.data.error === null) {
        let res = response.data.object
        res.forEach((item) => {
          if (item.needProduct === 1) {
            item.needProduct = 'force'
          } else if (item.needProduct === 0) {
            item.needProduct = 'notForce'
          } else if (item.needProduct === -1) {
            item.needProduct = 'prevent'
          }

          if (item.needProvider === 1) {
            item.needProvider = 'force'
          } else if (item.needProvider === 0) {
            item.needProvider = 'notForce'
          } else if (item.needProvider === -1) {
            item.needProvider = 'prevent'
          }
        })
        this.setState({
          tasks: response.data.object
        })

        if (response.data.object.length === 1) {
          let target = document.getElementById('taskId')

          sessionStorage.setItem('needProduct', target.options[target.selectedIndex].getAttribute('data-needProduct'))
          sessionStorage.setItem('taskType', response.data.object[0].id)
          sessionStorage.setItem('needProvider', target.options[target.selectedIndex].getAttribute('data-needProvider'))
          sessionStorage.setItem(
            'timeMinuteMin',
            target.options[target.selectedIndex].getAttribute('data-timeMinuteMin')
          )
          sessionStorage.setItem(
            'timeMinuteMax',
            target.options[target.selectedIndex].getAttribute('data-timeMinuteMax')
          )
          sessionStorage.setItem(
            'editableCount',
            target.options[target.selectedIndex].getAttribute('data-editableCount')
          )
          sessionStorage.setItem('defaultCount', target.options[target.selectedIndex].getAttribute('data-defaultCount'))

          this.setState({
            timeMinuteMin: target.options[target.selectedIndex].getAttribute('data-timeMinuteMin'),
            timeMinuteMax: target.options[target.selectedIndex].getAttribute('data-timeMinuteMax'),
            needProduct: target.options[target.selectedIndex].getAttribute('data-needProduct'),
            needProvider: target.options[target.selectedIndex].getAttribute('data-needProvider'),
            editableCount: target.options[target.selectedIndex].getAttribute('data-editableCount'),
            defaultCount: target.options[target.selectedIndex].getAttribute('data-defaultCount')
          })
        }
      } else {
        this.setState({
          tasks: []
        })
      }
    })
  }

  changeOrg(e) {
    let name = e.target.name
    let value = e.target.value
    if (value === '') {
      sessionStorage.removeItem('departmentId')
      sessionStorage.removeItem('sectionId')
      sessionStorage.removeItem('taskType')
      this.setState({
        sections: [],
        departmentId: '',
        sectionId: '',
        taskType: ''
      })
    } else {
      sessionStorage.setItem('departmentId', value)
      this.setState({
        departmentId: value
      })

      this.loadSections(value)
    }
  }

  getValueProvider = (providerId) => {
    alert(this.state.providerId)

    if (!providerId) {
      this.setState({
        products: [],
        providerId: [],
        productId: [],
        selectedProductFromList: []
      })
      sessionStorage.removeItem('providerId')
      sessionStorage.removeItem('productId')
    } else {
      this.setState(
        {
          providerId,
          selectedProductFromList: []
        },
        () => {}
      )
      sessionStorage.setItem('providerId', JSON.stringify(providerId))
      let id = providerId

      http
        .get(`${REPORT_RETAIL.REPORT_RETAIL_PRODUCT}?providerId=${id}&export=true&sortBy=productName_asc`, {
          params: {
            sortByTitle: true
          }
        })
        .then((response) => {
          if (response.data.error === null) {
            var products = response.data.object.result
            for (let i = 0; i < products.length; i++) {
              products[i]['value'] = products[i].productId
              products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
            }
            this.setState({
              products: response.data.object.result
            })
          } else {
            this.setState({
              products: []
            })
          }
        })
    }
  }

  getValueProduct = (productId) => {
    if (productId === null) {
      this.setState({
        productId: ''
      })
    } else {
      this.setState({
        productId
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.products !== this.state.products) {
      let productId = this.state.products.find((item) => item.productId === this.state.productId)
      if (productId) {
        this.setState({
          productId: productId
        })
      } else {
        this.setState({
          productId: ''
        })
      }
    }
  }

  validateMin = (evt) => {
    // if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57)
    // {
    //     evt.preventDefault();
    // }
  }
  changeCount = (e) => {
    this.setState({
      defaultCount: e.target.value
    })
  }

  changeActivityDate = (activityDate) => {
    this.setState({activityDate})
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  createTask = () => {
    let {timeMinuteMax, timeMinuteMin, selectedProductFromList, userId} = this.state
    let sectionId = document.getElementById('sectionId').value
    let departmentId = document.getElementById('departmentId').value
    let taskId = document.getElementById('taskId').value
    let timeMinuteUser = document.getElementById('timeMinuteUser').value
    let count = document.getElementById('count').value
    let description = document.getElementById('description').value.trim()

    let providerId = this.state.providerId
    let productId =
      this.state.productId === '' || this.state.productId.lenght === 0 || this.state.productId === null
        ? ''
        : this.state.productId.productId

    let activityDate = this.state.activityDate
    let nowDate = Number(this.convertDigit(jMoment().format('jYYYYjMMjDD')))
    let numberActivitiDate = Number(this.convertDigit(jMoment(activityDate).format('jYYYYjMMjDD')))
    let formErr = false

    let {needProduct, needProvider} = this.state
    if (
      needProvider === 'force' &&
      (sectionId === '' ||
        departmentId === '' ||
        taskId === '' ||
        timeMinuteUser === '' ||
        count === '' ||
        !providerId ||
        activityDate === '' ||
        !userId ||
        userId === '')
    ) {
      message.error('فیلد های ستاره دار وارد شود')
    } else if (
      needProduct === 'force' &&
      (sectionId === '' ||
        taskId === '' ||
        departmentId === '' ||
        timeMinuteUser === '' ||
        count === '' ||
        selectedProductFromList.length === 0 ||
        activityDate === '' ||
        !userId ||
        userId === '')
    ) {
      message.error('فیلد های ستاره دار وارد شود')
    } else if (
      sectionId === '' ||
      taskId === '' ||
      timeMinuteUser === '' ||
      departmentId === '' ||
      count === '' ||
      activityDate === '' ||
      !userId ||
      userId === ''
    ) {
      message.error('فیلد های ستاره دار وارد شود')
    } else if (activityDate === undefined) {
      message.error('تاریخ وارد شده معتبر نیست')
    } else if (numberActivitiDate > nowDate) {
      message.error('حداکثر تاریخ وارد شده باید امروز باشد')
    } else {
      let arrayOfProductIds = []
      selectedProductFromList.forEach((item) => {
        arrayOfProductIds.push(item.productId)
      })

      // alert('send')
      let lengthOfProduct = arrayOfProductIds.length === 0 ? 1 : arrayOfProductIds.length
      let data = {
        sectionId,
        taskId,
        timeMinuteUser,
        count: this.state.editableCount === 'true' ? count : count * lengthOfProduct,
        description,
        productIds: this.state.needProduct === 'prevent' ? null : arrayOfProductIds,
        providerId: this.state.needProvider === 'prevent' ? null : providerId,
        activityDate,
        departmentId,
        userId: userId.personId
      }

      //
      http.post(`${TMS.TMS_MANAGE_ACTIVITY_CREATE}`, data, {}).then((response) => {
        if (response.data.error === null) {
          message.success('فعالیت با موفقیت ثبت شد')
          setTimeout(() => {
            window.location.assign('/tms/manageTask/create')
          }, 1000)
        }
      })
    }
  }

  changeValue = (selectedProductFromList) => {
    console.log(selectedProductFromList)
    this.setState({
      selectedProductFromList
    })
  }
  all = () => {
    let products = this.state.products
    products.forEach((item) => {
      item.selected = true
    })
    this.setState({
      selectedProductFromList: products
    })
  }
  placeHolder = () => {
    if (this.state.selectedProductFromList.length > 1) {
      return this.state.selectedProductFromList.length + ' کالا انتخاب شده '
    } else if (this.state.selectedProductFromList.length === 1) {
      let selectedProduct = this.state.selectedProductFromList[0].productName
      return selectedProduct
    } else {
      return 'از لیست کالا ها انتخاب کنید'
    }
  }

  render() {
    return (
      <div className={'rtl'}>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>مدیریت وظایف</li>
            <li>مدیر</li>
            <li>ثبت فعالیت</li>
          </ul>
          <MDBContainer fluid className="mt-4 bg-white pb-2">
            <MDBRow>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.users}
                    getValueCombo={this.getUserValue}
                    lableText="کاربر"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    force={true}
                    className="font-weight-bold"
                  />
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    دپارتمان<span className="requireFiled">*</span>
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeOrg.bind(this)}
                    name="departmentId"
                    id="departmentId"
                  >
                    {this.state.department.length === 1 ? '' : <option value="">------</option>}
                    {this.state.department.map((item, index) => (
                      <option
                        value={item.id}
                        selected={Number(this.state.departmentId) === Number(item.id) ? true : false}
                        key={index}
                      >
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    بخش<span className="requireFiled">*</span>
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeSec.bind(this)}
                    name="sectionId"
                    id="sectionId"
                  >
                    {this.state.sections.length === 1 ? '' : <option value="">------</option>}
                    {this.state.sections.map((item, index) => (
                      <option
                        value={item.id}
                        selected={Number(this.state.sectionId) === Number(item.id) ? true : false}
                        key={index}
                      >
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    فعالیت<span className="requireFiled">*</span>
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeTaskType.bind(this)}
                    name="taskType"
                    id="taskId"
                  >
                    {this.state.tasks.length === 1 ? '' : <option value="">------</option>}

                    {this.state.tasks.map((item, index) => (
                      <option
                        data-timeMinuteMin={item.timeMinuteMin}
                        data-timeMinuteMax={item.timeMinuteMax}
                        data-needProduct={item.needProduct}
                        data-needProvider={item.needProvider}
                        data-editableCount={item.editableCount ? 'true' : 'false'}
                        data-defaultCount={item.defaultCount}
                        selected={Number(this.state.taskType) === item.id}
                        value={item.id}
                        key={index}
                      >
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
              </MDBCol>
              {this.state.needProvider !== 'prevent' && !this.state.init ? (
                <MDBCol xs={12} sm={6} md={3}>
                  <div className="formComponent selectComponent">
                    <AutoComplete
                      label="تامین کننده"
                      api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                      textField="title"
                      valueField="providerId"
                      id="provider"
                      required={this.state.needProvider === 'force' ? true : false}
                      value={this.state.providerId}
                      setValue={this.getValueProvider}
                    />
                    {/* <label className={'font-weight-bold'}>تامین کننده{this.state.needProvider === 'force' ? <span className='requireFiled'>*</span> : ''}</label>
                                        <Select
                                            options={this.state.providers}
                                            isClearable={true}
                                            placeholder={'------'}
                                            value={this.state.providerId}
                                            onChange={this.getValueProvider}
                                        /> */}
                  </div>
                </MDBCol>
              ) : null}

              {this.state.needProduct !== 'prevent' ? (
                <MDBCol xs={12} sm={6} md={3}>
                  <div className="formComponent searchableCheckbox">
                    <label className={'font-weight-bold'}>
                      {'کالا'}
                      {this.state.needProduct === 'force' ? <span className="requireFiled">*</span> : ''}
                    </label>
                    <span
                      onClick={this.all}
                      className="badge badge-info p-2 mx-2 font-weight-bold"
                      style={{cursor: 'pointer'}}
                    >
                      انتخاب همه
                    </span>
                    <ReactMultiSelectCheckboxes
                      placeholderButtonLabel="انتخاب کنید"
                      getDropdownButtonLabel={() => this.placeHolder()}
                      onChange={this.changeValue}
                      value={this.state.selectedProductFromList}
                      className="multiCheckbox"
                      options={this.state.products}
                    />
                  </div>
                </MDBCol>
              ) : // <MDBCol xs={12} sm={6} md={3}>
              //     <div className='formComponent'>
              //         <label className={'font-weight-bold'}>{'کالا'}{this.state.needProduct === 'force' ? <span className='requireFiled'>*</span> : ''}</label>
              //         <Select
              //             options={this.state.products}
              //             isClearable={true}
              //             placeholder={'------'}
              //             value={this.state.productId}
              //             onChange={this.getValueProduct}
              //         />
              //     </div>
              // </MDBCol>
              null}

              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  {/*<label className='font-weight-bold'>تاریخ<span className='requireFiled'>*</span></label>*/}
                  <SinglePicker label="تاریخ" id="picker" force defaulValue changeDate={this.changeActivityDate} />
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold">
                    زمان (دقیقه)<span className="requireFiled">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    min={1}
                    onKeyPress={this.validateMin.bind(this)}
                    id="timeMinuteUser"
                  />
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold">
                    تعداد<span className="requireFiled">*</span>
                  </label>
                  <input
                    type="number"
                    disabled={this.state.editableCount === 'true' ? false : true}
                    value={this.state.defaultCount}
                    onChange={this.changeCount}
                    className="form-control"
                    min={1}
                    onKeyPress={this.validateMin.bind(this)}
                    id="count"
                  />
                </div>
              </MDBCol>

              <MDBCol xs={12}>
                <div className="formComponent">
                  <label className="font-weight-bold">توضیحات</label>
                  <textarea id="description" className="form-control" />
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <button
                    className="btn btn-block"
                    style={{background: '#b2d234', fontSize: '1.2em'}}
                    onClick={this.createTask}
                  >
                    ثبت
                  </button>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </div>
      </div>
    )
  }
}

export default ManagerCreateTask
